import { VueI18nHelper } from '@/helpers/VueI18nHelper';
import Frontpage from './Frontpage.vue';
import config from '../../../config';

VueI18nHelper.initVueI18NextMultipleForPage(
  Frontpage,
  `.frontpage-vue`,
  [
    config.locize.frontPage.namespaces.FRONTPAGE,
    config.locize.frontPage.namespaces.PARTNERSHOP,
    config.locize.announcementBar.namespaces.UFE,
  ],
  [
    {
      projectId: config.locize.frontPage.PROJECTID,
      version: config.locize.frontPage.version,
    },
    {
      projectId: config.locize.announcementBar.PROJECTID,
      version: config.locize.announcementBar.version,
    },
  ],
);
